import cart from "./cart.json";
import coupon from "./coupon.json";
import category from "./category.json";
import product from "./product.json";
import productSort from "./productSort.json";
import productThumb from "./productThumb.json";
import wishlist from "./wishlist.json";
import returnState from "./return.json";
import productFolder from "./product/index";

export default {
  cart,
  coupon,
  category,
  productSort,
  productThumb,
  wishlist,
  returnState,
  product: { ...product, ...productFolder },
};
